import { QuestionnaireStatus } from '@/tax/models';

import { QuestionnaireSubmission } from './questionnaire-submission.model';
import { TaxToken } from './tax-token.model';

export class Questionnaire {
    published = true;
    status: QuestionnaireStatus = QuestionnaireStatus.Init;
    numPublishedQuestions = 0;
    numResponses = [0, 0];
    submissions = [undefined, undefined] as (QuestionnaireSubmission | undefined)[];
    dateSent?: Date;
    tokens = [] as TaxToken[];

    deserialize(data: any) {
        this.published = data.published ?? true;
        this.status = data.status ?? QuestionnaireStatus.Init;
        this.submissions =
            data.submissions !== null
                ? data.submissions.map((submission: any) =>
                      submission !== null ? new QuestionnaireSubmission().deserialize(submission) : undefined,
                  )
                : [undefined, undefined];
        this.numResponses = data.num_responses ?? [0, 0];
        this.numPublishedQuestions = data.num_published_questions ?? 0;
        this.dateSent = data.date_sent !== null ? new Date(data.date_sent) : undefined;
        this.tokens = (data.tokens ?? []).filter((token: any) => token !== null).map((token: any) => new TaxToken().deserialize(token));
        return this;
    }

    serialize() {
        return {
            published: this.published,
        };
    }

    clone() {
        let res = new Questionnaire();
        res.published = this.published;
        res.status = this.status;
        res.numPublishedQuestions = this.numPublishedQuestions;
        res.numResponses = [...this.numResponses];
        res.dateSent = this.dateSent !== undefined ? new Date(this.dateSent.toISOString()) : undefined;
        res.tokens = this.tokens.map((token) => token.clone());
        res.submissions = this.submissions.map((subm) => (subm !== undefined ? subm.clone() : undefined));
        return res;
    }
}
